import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFiatDeposit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M19.25 3.5a.75.75 0 0 0-1.5 0v1.75H16a.75.75 0 0 0 0 1.5h1.75V8.5a.75.75 0 0 0 1.5 0V6.75H21a.75.75 0 0 0 0-1.5h-1.75V3.5Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 3.75a8.25 8.25 0 1 0 8.155 6.996.75.75 0 1 1 1.483-.226c.074.483.112.977.112 1.48 0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25c.605 0 1.197.055 1.773.161a.75.75 0 0 1-.271 1.475A8.301 8.301 0 0 0 12 3.75ZM12.689 7a.75.75 0 0 0-1.5 0v.72h-.352a2.587 2.587 0 0 0 0 5.173h2.204a1.087 1.087 0 1 1 0 2.173H9.734a.75.75 0 0 0 0 1.5h1.455v.72a.75.75 0 0 0 1.5 0v-.72h.352a2.587 2.587 0 1 0 0-5.173h-2.204a1.087 1.087 0 0 1 0-2.174h3.306a.75.75 0 0 0 0-1.5h-1.454V7Z"
    />
  </svg>
);
export default SvgTwoColorFiatDeposit;
